module.exports = __webpack_public_path__ + "static/neogi-a3c5eda8e7d36cd86a682d69ba7fa98f.jpeg";